<template>
  <v-chip small outline>
    <v-avatar>
      <v-icon :color="instanceColor" v-bind="$attrs">{{ icon }}</v-icon>
    </v-avatar>
    {{ $t(status) }}
  </v-chip>
</template>

<script>
export default {
  props: ['status', 'color'],
  data() {
    return {
      instanceColor: '',
      icon: 'mdi-label-outline',
    };
  },
  mounted() {
    switch (this.status) {
      case 'active':
        this.icon = 'mdi-check-outline';
        this.instanceColor = 'success';
        break;
      case 'closed':
        this.icon = 'mdi-close-circle-outline';
        this.instanceColor = 'grey lighten-1';

        break;
      case 'trash':
        this.icon = 'mdi-trash-can-outline';
        this.instanceColor = 'error';

        break;

      default:
        this.icon = 'mdi-check-outline';
        this.instanceColor = 'success';

        break;
    }
    if (this.color) {
      this.instanceColor = this.color;
    }
  },
};
</script>
